import { render } from "./detail-sekolah.vue?vue&type=template&id=6eb03364&ts=true"
import script from "./detail-sekolah.vue?vue&type=script&lang=ts"
export * from "./detail-sekolah.vue?vue&type=script&lang=ts"

import "./detail-sekolah.vue?vue&type=style&index=0&id=6eb03364&lang=scss"
import "./detail-sekolah.vue?vue&type=style&index=1&id=6eb03364&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__